<script>
import TableGenericList from "@/components/instrument/TableGenericList"
import { mapState } from "vuex"

export default {
  name: "InstTable",
  components: {
    TableGenericList,
  },
  props: {
    site: {
      type: String,
      default: null,
    },
    facility: {
      type: String,
      default: null,
    },
    instrument: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      debounceTimer: null,
      instInfo: [],
      insts: [],
      allInstData: null,
      matchedInstData: null,
      fields: [
        { key: "instNumber", label: "NUMBER", sortable: true },
        { key: "instSite", label: "SITE", sortable: true },
        { key: "instFacility", label: "FACILITY", sortable: true },
        { key: "instClass", label: "INSTRUMENT", sortable: true },
      ],
    }
  },
  watch: {
    site() {
      this.filterInstruments()
    },
    facility() {
      this.filterInstruments()
    },
    instrument() {
      this.filterInstruments()
    },
    personInstruments: {
      handler() {
        this.getInstInfo()
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState("instrument", ["personInstruments"]),
    itemsLoaded() {
      return this.instInfo.length > 0
    },
  },
  created() {
    this.getInstInfo()
  },
  methods: {
    getInstInfo() {
      this.$store
        .dispatch("instrument/retrieveInstDataFromInstEndPoint")
        .then((data) => {
          if (!data || !data.result) {
            console.error("No data returned from endpoint")
            return
          }
          this.allInstData = data.result.map(item => ({
            instSysId: item["sys_id"],
            instSite: item["instrument.next_site_code"] || "",
            instFacility: item["instrument.next_facility_code"] || "",
            instClass: item["instrument.acronym"] || "",
            instNumber: item["number"] || "",
          }))
          this.matchedInstData = this.allInstData.filter(instItem => {
            return this.personInstruments.some(personInst => {
              const siteCode = personInst.siteCode && personInst.siteCode.trim() !== "" ? personInst.siteCode : null
              const facilityCode = personInst.facilityCode && personInst.facilityCode.trim() !== "" ? personInst.facilityCode : null
              const instrumentClassCode = personInst.instrumentClassCode && personInst.instrumentClassCode.trim() !== "" ? 
                personInst.instrumentClassCode.toLowerCase() : null
              const instClass = (instItem.instClass || "").toLowerCase()
              //match siteCode, facilityCode and instrumentClassCode from personInstruments with end point data based on different combinations of inputs 
              if (instrumentClassCode && !siteCode && !facilityCode) {
                return instrumentClassCode === instClass
              }
              if (siteCode && facilityCode && !instrumentClassCode) {
                return siteCode === instItem.instSite && 
                  facilityCode === instItem.instFacility
              }
              if (siteCode && instrumentClassCode && !facilityCode) {
                return siteCode === instItem.instSite && 
                  instrumentClassCode === instClass
              }
              if (siteCode && facilityCode && instrumentClassCode) {
                return siteCode === instItem.instSite && 
                  facilityCode === instItem.instFacility && 
                  instrumentClassCode === instClass
              }
              return false
            })
          }) 
          this.filterInstruments()
        })
        .catch(error => {
          console.error("Error fetching instrument data:", error)
          this.instInfo = []
        })
    },
    filterInstruments() {
      this.instInfo = this.matchedInstData.filter(instItem => {
        // show all matched instruments
        if (!this.site && !this.facility && !this.instrument) {
          return true
        }
        //filter table results based on picker selections
        if (this.instrument && !this.site && !this.facility) {
          const instrumentMatch = (instItem.instClass || "").toLowerCase() === this.instrument.toLowerCase()
          return instrumentMatch
        }
        if (this.site && this.facility && this.instrument) {
          const siteMatch = instItem.instSite === this.site
          const facilityMatch = instItem.instFacility === this.facility
          const instrumentMatch = (instItem.instClass || "").toLowerCase() === this.instrument.toLowerCase()
          return siteMatch && facilityMatch && instrumentMatch
        }
        if (this.site && this.facility) {
          const siteMatch = instItem.instSite === this.site
          const facilityMatch = instItem.instFacility === this.facility
          return siteMatch && facilityMatch
        }
        if (this.site) {
          const siteMatch = instItem.instSite === this.site
          return siteMatch
        }
        return false
      })
    },
  },
}
</script>

<template>
  <div id="tableView">
    <b-container class="gx-0">
      <b-row class="gx-0">
        <b-col class="gx-0">
          <div id="insts" class="tableContainer">
            <h6 class="font-weight-bold pt-2 px-2 pb-0 mb-0 sectionHeader">INSTs</h6>
            <TableGenericList :fields="fields" :records="instInfo" />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<style scoped>
.tableContainer {
  background: #95c8fb;
}
</style>
